import { Card, CardActionArea, CardHeader, CardMedia, useMediaQuery, useTheme } from '@mui/material'
import { FormOptionCardProps } from './props'
import { useNavigate } from 'react-router'
import links from '../../../../../routes/links'

export default function FormOptionCard(props: FormOptionCardProps) {
  const navigate = useNavigate()
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Card elevation={4} sx={{ height: '100%' }}>
      <CardActionArea onClick={() => navigate(props.link ?? links.public.home())} sx={{ height: '100%' }}>
        {!!props.bannerUrl ? (
          <CardMedia src={props.bannerUrl} alt={props.label} component='img' height={upMd ? '260' : '130'} />
        ) : null}
        <CardHeader title={props.label} subheader={props.subheader} slotProps={{ title: { textDecoration: 'none' } }} />
      </CardActionArea>
    </Card>
  )
}
